export default "__VITE_ASSET__67016b5f__"